<template>
	<div>This is a test component rendered with the help of webComand.</div>
</template>
<script>
	export default {
		setup(props, context) {
			console.log("Setup ran for component: 'test'");
		}
	};
</script>